import { useEffect, useRef, useState } from "@max/max";
const showPopupRequestQueue = [];
let globalSortStrategy = 'priority';
function checkAndShowTopPopup() {
    if (showPopupRequestQueue.length === 0) {
        return;
    }
    showPopupRequestQueue.forEach((popup, index) => {
        var _a;
        if (index === 0) {
            popup.callback();
        }
        else {
            (_a = popup.closeCallback) === null || _a === void 0 ? void 0 : _a.call(popup);
        }
    });
}
export function setPopupSortStrategy(strategy) {
    globalSortStrategy = strategy;
    sortQueue();
    checkAndShowTopPopup();
}
function sortQueue() {
    if (typeof globalSortStrategy === 'function') {
        showPopupRequestQueue.sort(globalSortStrategy);
    }
    else {
        switch (globalSortStrategy) {
            case 'priority':
                showPopupRequestQueue.sort((a, b) => a.priority - b.priority);
                break;
            case 'lifo':
                showPopupRequestQueue.sort((a, b) => b.priority - a.priority);
                break;
            case 'fifo':
            default:
                break;
        }
    }
}
export function useOrderPopup(initValue, priority = 0, delay = 0) {
    const [_visible, _setVisible] = useState(initValue);
    const hash = useRef(Math.random().toString(36).substring(2, 15));
    function setVisible(visible) {
        const runner = () => {
            const index = showPopupRequestQueue.findIndex(item => item.hash === hash.current);
            if (visible) {
                if (index === -1) {
                    const newRequest = {
                        hash: hash.current,
                        priority,
                        callback: () => _setVisible(true),
                        closeCallback: () => _setVisible(false)
                    };
                    showPopupRequestQueue.push(newRequest);
                    sortQueue();
                    checkAndShowTopPopup();
                }
                else {
                    checkAndShowTopPopup();
                }
            }
            else {
                if (index !== -1) {
                    showPopupRequestQueue.splice(index, 1);
                    _setVisible(false);
                    checkAndShowTopPopup();
                }
                else {
                    _setVisible(false);
                }
            }
        };
        if (delay) {
            setTimeout(runner, delay);
        }
        else {
            runner();
        }
    }
    useEffect(() => {
        if (initValue) {
            const newRequest = {
                hash: hash.current,
                priority,
                callback: () => _setVisible(true),
                closeCallback: () => _setVisible(false)
            };
            showPopupRequestQueue.push(newRequest);
            sortQueue();
            checkAndShowTopPopup();
        }
    }, [initValue, priority]);
    useEffect(() => {
        return () => {
            showPopupRequestQueue.splice(showPopupRequestQueue.findIndex(item => item.hash === hash.current), 1);
        };
    }, []);
    return [_visible, setVisible];
}
export function getPopupQueueStatus() {
    var _a;
    return {
        queue: showPopupRequestQueue.map(item => ({
            hash: item.hash,
            priority: item.priority
        })),
        topPriority: (_a = showPopupRequestQueue[0]) === null || _a === void 0 ? void 0 : _a.priority
    };
}
